import Expression from "./Expression";
import BuildExpression from "../BuildExpression";

class Equal extends Expression {
    calculate() {
        let result = false;

        if (this.items.length === 2) {
            result = this.items[0].calculate() === this.items[1].calculate();
        }

        return result;
    }

    _setItems() {
        this.expression?.arguments?.forEach((argument) => {
            this.add(BuildExpression.getClass(this.data, argument, this.index, this.tableIndex));
        });
    }
}

export default Equal;
